import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Siegel-4.png")